var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Auth',{staticClass:"wrap-home",on:{"loggedIn":_vm.loggedIn,"loginFailed":_vm.loginFailed}},[_c('div',{staticClass:"wrap-page"},[_c('Header',{attrs:{"headerContent":_vm.headerContent},on:{"onRight":_vm.onRight}}),_c('ModuleHome')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }